const SalesforceUsersMappings = () => import('@/views/account/integrations/salesforce/mappings/salesforce-users-mappings-view.vue');
const SalesforceCompaniesMappings = () => import('@/views/account/integrations/salesforce/mappings/salesforce-companies-mappings-view.vue');
const SalesforceContactsMappings = () => import('@/views/account/integrations/salesforce/mappings/salesforce-contacts-mappings-view');
const SalesforceActivitiesMappings = () => import('@/views/account/integrations/salesforce/mappings/salesforce-activities-mappings-view');
const SalesforceOpportunitiesMappings = () => import('@/views/account/integrations/salesforce/mappings/salesforce-opportunities-mappings-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/Salesforce/Manage/Users/Mappings',
        name: 'SalesforceUsersMappings',
        component: SalesforceUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage/Users/Mappings',
        name: 'ClientSalesforceUsersMappings',
        component: SalesforceUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/Salesforce/Manage/Companies/Mappings',
        name: 'SalesforceCompaniesMappings',
        component: SalesforceCompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage/Companies/Mappings',
        name: 'ClientSalesforceCompaniesMappings',
        component: SalesforceCompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/Salesforce/Manage/Contacts/Mappings',
        name: 'SalesforceContactsMappings',
        component: SalesforceContactsMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage/Contacts/Mappings',
        name: 'ClientSalesforceContactsMappings',
        component: SalesforceContactsMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/Salesforce/Manage/Activities/Mappings',
        name: 'SalesforceSalesforceActivitiesMappings',
        component: SalesforceActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage/Activities/Mappings',
        name: 'ClientSalesforceActivitiesMappings',
        component: SalesforceActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/Salesforce/Manage/Opportunities/Mappings',
        name: 'SalesforceOpportunitiesMappings',
        component: SalesforceOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage/Opportunities/Mappings',
        name: 'ClientSalesforceOpportunitiesMappings',
        component: SalesforceOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    }
]